import React, {Fragment} from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { useMicTypeSample } from '../../../hooks/micTypeSample/useMicTypeSample';
import { ModalMicTypeSample } from '../../../components/micTypeSample/ModalMicTypeSample';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexTypeSample = () => {
    const{
        typeSamples, name, abbreviation, validaciones,
        method, 
        handleInputChange, handleSearchType, loading, 
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        showDeleteAlert, closeDeleteAlert, modalAlert,

        closeDialog, loadingExport, handleExportTypeSample,
        searchTypeSample, handleSearch, handleClearTypeSample
    } = useMicTypeSample();
    
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
    
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_mic_type_sample)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_mic_type_sample)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    
    return(
        <>
            <Fragment>
                <div className='container-global-zoom'>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody className="p-1">

                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                        <TitleDataTable
                                            titleTable="Listado de tipos de muestras"
                                            buttonActions={handleExportTypeSample}
                                            titleButton="Excel de tipos de muestras"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear Laboratorio"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchTypeSample}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClearTypeSample}
    
                                        />
                                    </Col>
                                
                                    <div className="table-responsive">
                                        <DataTable
                                            value={typeSamples}
                                            paginator
                                            rows={10}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[10, 50, 100]} 
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
    
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="abbreviation" header="Abreviación" headerStyle={headerStyle} style={cellStyle} />
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>

                                    {showDeleteAlert && (
                                        <AlertDataTable
                                            titleAlert="Eliminar tipo de muestra"
                                            visibleAlert={modalAlert}
                                            onHideAlert={closeDeleteAlert}
                                            sizeAlert="medium-dialog delete-method"
                                            messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar el tipo de muestra?"
                                            alert1={true}
                                            titleAlert1={name}
                                            buttonAcept
                                            titleNotLoading="Eliminar"
                                            titleDanger="Cancelar"
                                            actionAcept={saveDelete}
                                        />
            
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <ModalMicTypeSample
                {
                    ...{
                        modal, modalTitle, toggle, method, loading,
                        name, abbreviation, handleInputChange, 
                        validaciones, saveCreate, saveUpdate, closeDialog
                    }
                }
                />
            </Fragment>
        </>
    )
}
